(function($) {

	'use strict';

	function init() {
        initListeners();
	};

    function initListeners() {

        // Ouverture / /Fermeture au clic
        $('.flexAccordion__repeat__item').on('click keypress', function() {
            $(this).toggleClass('open');
        });

        $('.item__contents').each(function() {
            $(this).css('max-height', $(this)[0].scrollHeight);
        });

        $(window).resize(function() {
            $('.item__contents').each(function() {
                $(this).css('max-height', $(this)[0].scrollHeight);
            });
        }).resize();
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
